import CrudRequest from 'Domain/CrudRequest';
import HttpService from 'Support/services/HttpService';

export default class CommunicationCrudRequest extends CrudRequest {
  static save(id, payload) {
    return HttpService.post(
      `${this.baseUrl()}/${id}`,
      payload,
    );
  }
}
